"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanRenderer = exports.BooleanControl = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
const core_1 = require("@jsonforms/core");
const antd_1 = require("antd");
const Checkbox_1 = require("../antd/Checkbox");
const react_1 = require("@jsonforms/react");
function BooleanControl({ data, visible, label, id, enabled, uischema, schema, rootSchema, handleChange, errors, path, config, description, }) {
    const isValid = errors.length === 0;
    const appliedUiSchemaOptions = {
        ...config,
        ...uischema.options,
    };
    const showDescription = !(0, core_1.isDescriptionHidden)(visible, description, 
    // this comment is copypasta, may be removed:
    // Checkboxes do not receive focus until they are used, so
    // we cannot rely on focus as criteria for showing descriptions.
    // So we pass "false" to treat it as unfocused.
    false, !!appliedUiSchemaOptions.showUnfocusedDescription);
    const showTooltip = !showDescription && !(0, core_1.isDescriptionHidden)(visible, description, true, true);
    const formItemProps = "formItemProps" in uischema ? uischema.formItemProps : {};
    const tooltip = showTooltip && description ? description : undefined;
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { id: id, name: path, initialValue: data ?? schema.default, tooltip: tooltip, ...formItemProps, children: (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { id: `${id}-input`, isValid: isValid, data: data, enabled: enabled, label: label, visible: visible, path: path, uischema: uischema, schema: schema, rootSchema: rootSchema, handleChange: handleChange, errors: errors, config: config }) }));
}
exports.BooleanControl = BooleanControl;
exports.BooleanRenderer = (0, react_1.withJsonFormsControlProps)(BooleanControl);
